__turbopack_context__.v({
  "active": "AliasList-module-scss-module__TMM3iW__active",
  "alias-card-wrapper": "AliasList-module-scss-module__TMM3iW__alias-card-wrapper",
  "alias-list-container": "AliasList-module-scss-module__TMM3iW__alias-list-container",
  "category-filter": "AliasList-module-scss-module__TMM3iW__category-filter",
  "clear-filters-button": "AliasList-module-scss-module__TMM3iW__clear-filters-button",
  "controls": "AliasList-module-scss-module__TMM3iW__controls",
  "empty-state-message": "AliasList-module-scss-module__TMM3iW__empty-state-message",
  "is-visible": "AliasList-module-scss-module__TMM3iW__is-visible",
  "match-count": "AliasList-module-scss-module__TMM3iW__match-count",
  "new-alias-button": "AliasList-module-scss-module__TMM3iW__new-alias-button",
  "string-filter": "AliasList-module-scss-module__TMM3iW__string-filter",
  "string-filter-toggle": "AliasList-module-scss-module__TMM3iW__string-filter-toggle",
});
